import BaseApi from '@/api//base';
import { getImpersonationParams } from '@/util';

const setPhotosHeader = (params = {}) => ({
  ...params,
  headers: {
    type: 'PORTAL'
  }
});
const getMyPhotos = (jobId: string, noOfRecords = 0) => BaseApi.get('', { baseURL: process.env.VUE_APP_PHOTOS_API_BASE_URL, params: getImpersonationParams({ jobid: jobId, noOfRecords }) });

const uploadPhoto = (data: any, params = {}) => BaseApi.post('photo/create', data, setPhotosHeader(params));

const deletePhoto = (data: any, params = {}) => BaseApi.post('photo/delete', data, setPhotosHeader(params));

const uploadHomeProfilePhoto = (data: any, params = {}) => BaseApi.post('home/updatePhoto', data, setPhotosHeader(params));

export { getMyPhotos, uploadPhoto, deletePhoto, uploadHomeProfilePhoto };
